import BaseApi from '@/api/base-api'
import request from '@/utils/request'

class OrdersStatusApi extends BaseApi {
  authoriseOrder = (orderId, { merchantId }) => {
    return request({
      method: 'POST',
      path: this.uri + `/${orderId}/authorise`,
      data: {
        merchant_id: merchantId,
      },
    })
  }
}

export default new OrdersStatusApi('/orders')
